// vue
import { ref } from '@vue/composition-api';

// d3
import * as d3 from 'd3';

// turf
import { booleanClockwise } from '@turf/turf';

export const useBlueprintHook = () => {
    const svg = ref();

    const createSvg = (geojson: any, options: any) => {
        if (!options.padding) {
            options.padding = 0;
        }

        if (!geojson) {
            return null;
        }

        const svg = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'svg',
        );

        svg.style.backgroundColor = options.color;

        svg.setAttribute('width', options.width);
        svg.setAttribute('height', options.height);

        // reverse winding order if counter-clockwise
        if (!booleanClockwise(geojson.geometry.coordinates[0])) {
            geojson = {
                ...geojson,
                geometry: {
                    ...geojson.geometry,
                    coordinates: [geojson.geometry.coordinates[0].reverse()],
                },
            };
        }

        let projection = d3.geoMercator().fitExtent(
            [
                [options.padding, options.padding],
                [
                    options.width - options.padding,
                    options.height - options.padding,
                ],
            ],
            geojson,
        );

        let path = d3.geoPath().projection(projection);

        d3.select(svg)
            .selectAll('path')
            .data([geojson])
            .enter()
            .append('path')
            .attr('d', path)
            .attr('fill', 'none')
            .attr('stroke-width', options.strokeWidth)
            .attr('stroke', options.stroke);
        /* .append('rect')
            .attr('width', '100%')
            .attr('height', '100%')
            .attr('fill', options.color); */

        return svg;
    };

    const drawGrid = (
        width: number,
        height: number,
        gridLineWidth: number,
        svg: SVGSVGElement,
    ) => {
        for (let i = 5; i < width; i += 5) {
            d3.select(svg)
                .append('line')
                .attr('x1', i)
                .attr('y1', 0)
                .attr('x2', i)
                .attr('y2', width)
                .attr('stroke', i % 25 === 0 ? '#ffffff44' : '#ffffff11')
                .attr('stroke-width', gridLineWidth);

            d3.select(svg)
                .append('line')
                .attr('y1', i)
                .attr('x1', 0)
                .attr('y2', i)
                .attr('x2', height)
                .attr('stroke', i % 25 === 0 ? '#ffffff44' : '#ffffff11')
                .attr('stroke-width', gridLineWidth);
        }
    };

    return {
        createSvg,
        drawGrid,
    };
};
